import { render, staticRenderFns } from "./tw_search.vue?vue&type=template&id=3dcd5b98&"
import script from "./tw_search.vue?vue&type=script&lang=js&"
export * from "./tw_search.vue?vue&type=script&lang=js&"
import style0 from "./tw_search.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports